import { computed, observable } from 'mobx';
import { DEFAULT_STATUS, ERROR_STATUS, OtpStatus } from '~constants/Constants';

export type OtpStateData = {
    isLoading: boolean;
    errorMessage?: string;
    successMessage?: string;
    codeStatus: OtpStatus;
    needResetToDefault: boolean;
    shouldDisplayRetryButton: boolean;
    verifiedCodes: string;
    isVerified: boolean;
};

export class OtpStateHelper {
    @observable private errorMessage: string;
    @observable private successMessage: string;
    @observable private isLoading: boolean = false;
    @observable private needResetToDefault: boolean;
    @observable private shouldDisplayRetryButton: boolean;
    @observable private codeStatus: OtpStatus = DEFAULT_STATUS;
    @observable private verifiedCodes: string = '';

    constructor() {
        this.isLoading = false;
        this.codeStatus = DEFAULT_STATUS;
        this.needResetToDefault = false;
        this.shouldDisplayRetryButton = false;
    }

    @computed
    public get data() {
        return {
            isLoading: this.isLoading,
            errorMessage: this.errorMessage,
            successMessage: this.successMessage,
            codeStatus: this.codeStatus,
            needResetToDefault: this.needResetToDefault,
            shouldDisplayRetryButton: this.shouldDisplayRetryButton,
            isVerified: this.isVerified,
            verifiedCodes: this.verifiedCodes
        } as OtpStateData;
    }

    public get isVerified() {
        return this.codeStatus === 'verified';
    }

    public setVerifiedCodes = (codes: string) => {
        this.verifiedCodes = codes;

        return this;
    };

    public setInitialStatus = () => {
        this.errorMessage = '';
        this.successMessage = '';
        this.needResetToDefault = false;

        return this;
    };

    public setRetryButtonVisibility = (needRetry: boolean) => {
        this.shouldDisplayRetryButton = needRetry;

        return this;
    };

    public startLoading = () => {
        this.isLoading = true;
        this.setInitialStatus();

        return this;
    };

    public stopLoading = () => {
        this.isLoading = false;
        this.needResetToDefault = true;

        return this;
    };

    public setErrorMessage = (translationKey: string) => {
        this.errorMessage = translationKey;
        this.successMessage = '';
        this.codeStatus = ERROR_STATUS;

        return this;
    };

    public setSuccessMessage = (translationKey: string, status: OtpStatus) => {
        this.errorMessage = '';
        this.successMessage = translationKey;
        this.codeStatus = status;

        return this;
    };

    public setCodeStatus = (status: OtpStatus) => {
        this.codeStatus = status;

        return this;
    };
}
